import React from "react";
import PropTypes from "prop-types";
import { Col, Input, Row, Select, DatePicker, Spin } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import "./Filter.css";
import Button from "../Button/PFButton";
import { paginationDefaults } from "../../../utils/properties";
import { indexOf } from "lodash";
const { RangePicker } = DatePicker;

const FilterField = (field) => {
  if (field.type === "input") {
    return (
      <Input
        key={field.id}
        id={field.id}
        name={field.name}
        placeholder={field.label}
        onChange={field.onChange}
        onBlur={field.onBlur}
        value={field.value}
        disabled={field.disabled}
      />
    );
  } else if (field.type === "select") {
    return (
      <Select
        allowClear={field.allowClear}
        id={field.id}
        name={field.name}
        className="w-100"
        placeholder={field.label}
        onChange={field.onChange}
        onBlur={field.onBlur}
        value={field.value}
        options={field.dataSelect}
        disabled={field.disabled}
        mode={field.mode}
      ></Select>
    );
  } else if (field.type === "selectWithSearch") {
    return (
      <Select
        allowClear={field.allowClear}
        className="w-100"
        id={field.id}
        name={field.name}
        showSearch
        placeholder={field.placeholder}
        onChange={field.onChange}
        onBlur={field.onBlur}
        onSearch={field.onSearch}
        value={field.value}
        disabled={field.disabled}
        loading={field.loading}
        options={field.dataSelect}
        optionFilterProp={field.optionFilterProp || "label"}
        filterOption={field.filterOption || false}
        notFoundContent={field.loading ? <Spin size="small" /> : null}
        mode={field.mode}
      />
    );
  } else if (field.type === "rangeMonth") {
    return (
      <RangePicker
        picker="month"
        id={field.id}
        name={field.name}
        format={field.format}
        locale={field.locale}
        value={field.value}
        onChange={field.onChange}
      />
    );
  } else if (field.type === "year") {
    return (
      <DatePicker
        allowClear={field.allowClear}
        picker="year"
        id={field.id}
        name={field.name}
        format={field.format}
        locale={field.locale}
        value={field.value}
        onChange={field.onChange}
      />
    );
  } else if (field.type === "month") {
    return (
      <DatePicker
        allowClear={false}
        picker="month"
        id={field.id}
        name={field.name}
        format={field.format}
        locale={field.locale}
        value={field.value}
        onChange={field.onChange}
      />
    );
  } else if (field.type === "date") {
    return (
      <DatePicker
        allowClear={field.allowClear}
        id={field.id}
        name={field.name}
        format={field.format}
        locale={field.locale}
        value={field.value}
        onChange={field.onChange}
      />
    );
  } else {
    return "";
  }
};

const buttonsOffset = (projectManagenent, isReportTimesheetPm, allInOneRow, fields) => {
  if (projectManagenent || isReportTimesheetPm || allInOneRow) {
    return 0;
  } else {
    if (fields.length === 1) {
      return 8;
    } else if (fields.length > 3) {
      return fields.length % 3 === 0 ? 16 : 8 * (fields.length % 3);
    } else {
      return 0;
    }
  }
};

const Filter = ({
  formikForm,
  fields,
  loading = false,
  onReset,
  allInOneRow = false,
  projectManagenent = false,
  isReportTimesheetPm = false,
  submitIcon,
}) => {
  const resetData = () => {
    formikForm.handleReset();
    onReset(paginationDefaults.page); // I pass start page
  };
  return (
    <div className="filter-container">
      <Row gutter={[48, 32]} align="bottom">
        {fields.map(
          (field, i) =>
            indexOf([false, undefined], field.hidden) !== -1 && (
              <Col
                key={field.id}
                lg={allInOneRow ? 24 / fields.length : 8}
                md={allInOneRow ? 24 / fields.length : 8}
                xs={24}
                offset={projectManagenent && i === 1 ? 2 : 0}
              >
                <Row>
                  <label className="fw-bold mt-10 mb-5" htmlFor={field.id}>
                    {field.label}
                    {field.isRequired ? "*" : ""}
                  </label>
                </Row>
                <Row>{FilterField(field)}</Row>
              </Col>
            )
        )}
        <Col
          lg={isReportTimesheetPm || allInOneRow || projectManagenent ? 24 : 8}
          md={isReportTimesheetPm || allInOneRow || projectManagenent ? 24 : 8}
          xs={24}
          offset={buttonsOffset(projectManagenent, isReportTimesheetPm, allInOneRow, fields)}
        >
          <Row justify="end">
            <Col>
              <Button
                type="secondary"
                currentSize="large"
                isLoading={loading}
                clickCallback={resetData}
                currentIcon={<ClearOutlined className="icon-large" />}
              />
            </Col>
            <Col className="left-margin">
              <Button
                isDisabled={!formikForm.isValid}
                currentSize="large"
                isLoading={loading}
                clickCallback={formikForm.submitForm}
                currentIcon={submitIcon || <SearchOutlined className="icon-large" />}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

Filter.propTypes = {
  formikForm: PropTypes.object.isRequired,
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
  onReset: PropTypes.func.isRequired,
  allInOneRow: PropTypes.bool,
  projectManagenent: PropTypes.bool,
  isReportTimesheetPm: PropTypes.bool,
};

export default Filter;
